module.exports = __webpack_public_path__ + "static/media/pebbble3.e83e3c3a.png";